
import { DxColumn, DxPager, DxPaging, DxScrolling, DxSelection, DxTreeList } from "devextreme-vue/tree-list";
import { Component, VModel, Vue } from "vue-property-decorator";

import { apiUrls } from "@/environment/environment";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { SelectionChangedEvent } from "devextreme/ui/tree_list";
import IndexationController from "../../shared/services/controllers/indexation/indexationController";
import { Societe } from "../../shared/types/Indexation";

@Component({
  components: {
    DxTreeList,
    DxSelection,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxPager,
  },
})
export default class IndexationSelectionGrille extends Vue {
  @VModel() selectedRowKeys!: number[];

  private controller: IndexationController;

  constructor() {
    super();
    this.controller = new IndexationController(apiUrls.indexation);
  }

  onSelectionChanged(e: SelectionChangedEvent) {
    const selectedData = e.component.getSelectedRowsData("leavesOnly");
    this.selectedRowKeys = selectedData.map((s: Societe) => {
      return s.id;
    });
  }

  storeSocieteTiers = new CustomStore({
    key: "id,code",
    load: async () => {
      const result = await this.controller.indexationStore.getSocieteTiers();
      return {
        data: result.data,
        totalCount: result.itemsCount,
      };
    },
  });

  dataSourceSocieteTiers = new DataSource({
    store: this.storeSocieteTiers,
  });
}
